import loadable from '@loadable/component';

export const UserDashboardEmploymentProfileOnboardingPageLoadable = loadable(
  () => import('./UserDashboardEmploymentProfileOnboardingPage'),
  {
    resolveComponent: (module) =>
      module.UserDashboardEmploymentProfileOnboardingPage,
  },
);
